import { render } from "./my_shop.html?vue&type=template&id=288ca0f6&external"
import script from "./my_shop.js?vue&type=script&lang=js&external"
export * from "./my_shop.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__